import type { WeeklyPlanDay } from '@gb-ticket/shared-types';

export type WeeklyPlanRange = 'today' | 'three' | 'week';

export type TimeColumnReason = 'outside-week' | 'no-column';

export function timeColumns(
  today: WeeklyPlanDay | null,
  columnKeys: readonly WeeklyPlanDay[],
  range: WeeklyPlanRange,
): { days: WeeklyPlanDay[]; reason: TimeColumnReason | null } {
  if (range === 'week') {
    return { days: [...columnKeys], reason: null };
  }
  if (today === null) {
    return { days: [], reason: 'outside-week' };
  }
  const index = columnKeys.indexOf(today);
  if (index < 0) {
    return { days: [], reason: 'no-column' };
  }
  if (range === 'today') {
    return { days: columnKeys.slice(index, index + 1), reason: null };
  }
  return { days: columnKeys.slice(index, index + 3), reason: null };
}
